import { PageConfig } from '../Configuration/IConfiguration';
import PagePasswordReset from './Pages/PagePasswordReset';
import PageActivateAccount from './Pages/PageActivateAccount';

export const basePageConfig: PageConfig[] = [
]